import { Action } from '@/_core/fluxstore/types';
import cloneDeep from 'lodash/cloneDeep';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class CreateEmptyPersona extends Action<StorymapState> {
    public static ACTION_TYPE = 'CreateEmptyPersona';

    public constructor(public newId: string) {
        super(CreateEmptyPersona.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CreateEmptyPersona): void => {
    const defaultPersonaPicture = state.personaPictures.find(x => x.id == "0");
    state.personas.push({
        id: action.newId,
        isNew: true,
        group: null,
        description: null,
        name: null,
        isGlobal: false,
        picture: defaultPersonaPicture.path,
        customFields: cloneDeep(state.defaultPersonaCustomFields),
        personalities: cloneDeep(state.defaultPersonaPersonalities)
    });
};

//@ts-ignore
registerReducer(CreateEmptyPersona.ACTION_TYPE, reducer);
